import React from "react";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface LoanHistoryRowProps {
    loanHistory: Record<string, any>;
}

export const LoanHistoryRow = ({
                                   loanHistory
                               }: LoanHistoryRowProps) => {

    return (
        <tr id={loanHistory.id}>
            <td>
                {loanHistory.barCode}
            </td>
            <td>
                {loanHistory.title} &ndash; {loanHistory.format}
                <div>{loanHistory.isbn ? `isbn: ${loanHistory.isbn}` : ""}</div>
            </td>
            <td>
                {loanHistory.patronName}
            </td>
            <td>
                {loanHistory.studentName}
            </td>
            <td>
                {loanHistory.shippingLocationName}
            </td>
            <td>
                {loanHistory.dateCheckedOutFormatted}
            </td>
            <td>
                {loanHistory.dateReturnedFormatted}
            </td>
            {
                isAdmin() &&
                <td>
                    {loanHistory.dateOrderSentToVendorFormatted}
                </td>
            }
        </tr>
    );
};